<template>
  <span data-testid="form-label" class="block pb-0.5 text-sm font-medium">
    <slot />
  </span>
</template>
